module.exports = __webpack_public_path__ + "static/media/proofpoint-logo-black.68311165.svg";